import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReplicateInformationComponent } from './replicate-information.component';
import { ListReplicateInformationComponent } from './list-replicate-information/list-replicate-information.component';
import { ReplicateInformationDetailsComponent } from './replicate-information-details/replicate-information-details.component';

const routes: Routes = [{
  path: '',
  component: ReplicateInformationComponent,
  children:
    [{
      path: '',
      component: ListReplicateInformationComponent,
      data: {
        title: 'Transacciones Salesforce',
        id: 'ReplicateInformationComponent_salesforceTransactions'
      }
    },
    {
      path: ':code',
      component: ReplicateInformationDetailsComponent,
      data: {
        title: 'Transacciones Salesforce',
        id: 'ReplicateInformationComponent_salesforceTransactions'
      }
    }]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReplicateInformationRoutingModule { }
